/* import __COLOCATED_TEMPLATE__ from './reviewable-field-editor.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-field-editor.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));